export const DEFAULT_MAINTENANCE_TIME = { hours: 0, minutes: 0, seconds: 0 };